import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "template-config" }
const _hoisted_2 = { class: "tab-bar" }
const _hoisted_3 = {
  class: "operation-bar",
  style: {"margin-bottom":"16px"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "pagination-bar" }
const _hoisted_7 = {
  class: "drawer-footer",
  style: {"position":"absolute","bottom":"0","width":"100%","border-top":"1px solid #e8e8e8","padding":"10px 16px","text-align":"right","left":"0","background":"#fff"}
}

import { ref, reactive } from 'vue'

// 定义数据类型接口
interface TemplateRecord {
  id: number
  type: string
  name: string
  code: string
  content: string
  createTime: string
}

interface FormState {
  name: string
  type: string
  code: string
  content: string
  variables: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TemplateConfig',
  setup(__props) {

const tabKey = ref('all')
const drawerVisible = ref(false)
const isEdit = ref(false)

// 表单数据
const formState = reactive<FormState>({
  name: '',
  type: 'email',
  code: '',
  content: '',
  variables: ''
})

const columns = [
  { title: '序号', dataIndex: 'id', key: 'id' },
  { title: '模板类型', dataIndex: 'type', key: 'type' },
  { title: '模板名称', dataIndex: 'name', key: 'name' },
  { title: '模板编码', dataIndex: 'code', key: 'code' },
  { title: '创建时间', dataIndex: 'createTime', key: 'createTime' },
  { title: '操作', key: 'action' }
]

const dataSource: TemplateRecord[] = [
  { id: 1, type: '邮件模板', name: '用户注册通知', code: 'EMAIL_REGISTER', content: '尊敬的${name}，您好！感谢您注册我们的服务...', createTime: '2024-01-15 10:00:00' },
  { id: 2, type: '短信模板', name: '验证码通知', code: 'SMS_VERIFY_CODE', content: '您的验证码是${code}，5分钟内有效，请勿泄露给他人。', createTime: '2024-01-16 11:30:00' },
  { id: 3, type: '企业微信模板', name: '告警通知', code: 'WECOM_ALERT', content: '【告警通知】\n设备：${device}\n时间：${time}\n告警内容：${content}', createTime: '2024-01-17 09:15:00' }
]

// 显示抽屉
function showDrawer() {
  isEdit.value = false
  resetForm()
  drawerVisible.value = true
}

// 关闭抽屉
function closeDrawer() {
  drawerVisible.value = false
}

// 重置表单
function resetForm() {
  formState.name = ''
  formState.type = 'email'
  formState.code = ''
  formState.content = ''
  formState.variables = ''
}

// 编辑模板
function handleEdit(record: TemplateRecord) {
  isEdit.value = true
  formState.name = record.name
  formState.type = record.type === '邮件模板' ? 'email' : 
                  record.type === '短信模板' ? 'sms' : 
                  record.type === '企业微信模板' ? 'wecom' : 'dingtalk'
  formState.code = record.code
  formState.content = record.content
  formState.variables = ''
  drawerVisible.value = true
}

// 删除模板
function handleDelete(record: TemplateRecord) {
  // 实际项目中应该调用API删除数据
  console.log('删除模板', record)
}

// 提交表单
function handleSubmit() {
  // 实际项目中应该调用API保存数据
  console.log('提交表单', formState)
  drawerVisible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "inline",
          class: "search-bar"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "模板名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入模板名称",
                  style: {"width":"180px"}
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "模板类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入模板类型",
                  style: {"width":"180px"}
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { type: "primary" }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode("查询")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, null, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("重置")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            type: "default",
            class: _normalizeClass({ active: tabKey.value === 'all' }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (tabKey.value = 'all'))
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("全部")
            ])),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_a_button, {
            type: "default",
            class: _normalizeClass({ active: tabKey.value === 'email' }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (tabKey.value = 'email'))
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("邮件模板")
            ])),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_a_button, {
            type: "default",
            class: _normalizeClass({ active: tabKey.value === 'sms' }),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (tabKey.value = 'sms'))
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("短信模板")
            ])),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_a_button, {
            type: "default",
            class: _normalizeClass({ active: tabKey.value === 'wecom' }),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (tabKey.value = 'wecom'))
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode("企业微信模板")
            ])),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_a_button, {
            type: "default",
            class: _normalizeClass({ active: tabKey.value === 'dingtalk' }),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (tabKey.value = 'dingtalk'))
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode("钉钉模板")
            ])),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: showDrawer
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode("新建模板")
            ])),
            _: 1
          })
        ]),
        _createVNode(_component_a_table, {
          columns: columns,
          "data-source": dataSource,
          pagination: false,
          style: {"margin-top":"16px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("a", {
                    onClick: () => handleEdit(record),
                    style: {"margin-right":"8px","color":"#1677ff"}
                  }, "编辑", 8, _hoisted_4),
                  _createElementVNode("a", {
                    onClick: () => handleDelete(record),
                    style: {"color":"#ff4d4f"}
                  }, "删除", 8, _hoisted_5)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, "共有 " + _toDisplayString(dataSource.length) + " 条数据", 1),
          _createVNode(_component_a_pagination, {
            total: dataSource.length,
            pageSize: 10,
            current: 1,
            style: {"margin":"0 16px"}
          }, null, 8, ["total"]),
          _createVNode(_component_a_select, {
            value: 10,
            style: {"width":"90px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select_option, { value: 10 }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode("10条/页")
                ])),
                _: 1
              }),
              _createVNode(_component_a_select_option, { value: 20 }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode("20条/页")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_drawer, {
      title: isEdit.value ? '编辑模板' : '新建模板',
      visible: drawerVisible.value,
      onClose: closeDrawer,
      width: "600"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: formState,
          layout: "vertical"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "模板名称",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formState.name,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formState.name) = $event)),
                  placeholder: "请输入模板名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "模板类型",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: formState.type,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((formState.type) = $event)),
                  placeholder: "请选择模板类型"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "email" }, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createTextVNode("邮件模板")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "sms" }, {
                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                        _createTextVNode("短信模板")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "wecom" }, {
                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                        _createTextVNode("企业微信模板")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "dingtalk" }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode("钉钉模板")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "模板编码",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formState.code,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((formState.code) = $event)),
                  placeholder: "请输入模板编码"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "模板内容",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: formState.content,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((formState.content) = $event)),
                  placeholder: "请输入模板内容",
                  rows: 6
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "变量说明" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: formState.variables,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((formState.variables) = $event)),
                  placeholder: "请输入变量说明，例如：${name}：用户名称",
                  rows: 4
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, { onClick: closeDrawer }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [
                  _createTextVNode("取消")
                ])),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: handleSubmit
              }, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [
                  _createTextVNode("确定")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["title", "visible"])
  ]))
}
}

})